module.exports = __webpack_public_path__ + "static/media/flag_long.5323a3ac.png";